export const audioMimeType =
  'audio/aac, audio/midi, audio/x-midi, audio/mpeg, audio/ogg, audio/opus audio/wav, audio/webm, audio/3gpp, audio/3gpp2,';
